export enum VorlageLinkRel {
	UPLOAD_FILE = 'fileUpload',
	FILE = 'file',
	DELETE = 'delete',
}

export enum VorlageListLinkRel {
	VORLAGE_LIST = 'vorlageList',
}
